module.exports = __webpack_public_path__ + "img/loader.9232a168.svg";